import { useState } from "react";
import FileUploadField from "../../components/FileUploadField";
import FormSuccess from "../../components/FormSuccess";
import { useSubmission } from "../../utils/useSubmission";

const BLANK = {
  fullName: "", nationality: "South Korea", email: "", phone: "",
  desiredRole: "", yearsExperience: "", availability: "", notes: "",
};

export default function JobSeekerPage() {
  const [f, setF] = useState(BLANK);
  const [files, setFiles] = useState([]);
  const { submitting, error, setError, success, submit } = useSubmission({
    collectionName: "jobSeekers", storageFolder: "job-seekers",
  });

  const set = (k, v) => setF(prev => ({ ...prev, [k]: v }));

  const onSubmit = e => {
    e.preventDefault();
    if (!f.fullName || !f.email || !f.desiredRole) {
      setError("Please fill in all required fields.");
      return;
    }
    submit(f, files);
  };

  if (success) {
    return (
      <section className="sec"><div className="container">
        <FormSuccess title="Registration Received"
          message="Thank you for registering your interest. Your CV and details have been added to our records and will be shared with relevant employers in the Papua LNG Project's Korean logistics and construction chain." />
      </div></section>
    );
  }

  return (
    <>
      <div className="pg-hdr">
        <h1>Job Seeker Registration</h1>
        <p>For Korean workers and tradespeople seeking a role on the Papua LNG Project.</p>
      </div>
      <section className="sec">
        <div className="container">
          <form className="form-card fade-up" onSubmit={onSubmit}>
            {error && <div className="form-err-banner">{error}</div>}

            <div className="field-row">
              <div className="field">
                <label>Full Name <span className="req">*</span></label>
                <input value={f.fullName} onChange={e => set("fullName", e.target.value)} required/>
              </div>
              <div className="field">
                <label>Nationality</label>
                <input value={f.nationality} onChange={e => set("nationality", e.target.value)}/>
              </div>
            </div>

            <div className="field-row">
              <div className="field">
                <label>Email <span className="req">*</span></label>
                <input type="email" value={f.email} onChange={e => set("email", e.target.value)} required/>
              </div>
              <div className="field">
                <label>Phone</label>
                <input value={f.phone} onChange={e => set("phone", e.target.value)}/>
              </div>
            </div>

            <div className="field">
              <label>Desired Role / Trade <span className="req">*</span></label>
              <input value={f.desiredRole} onChange={e => set("desiredRole", e.target.value)}
                placeholder="e.g. Crane Operator, Marine Engineer, Welder, Project Manager" required/>
            </div>

            <div className="field-row">
              <div className="field">
                <label>Years of Relevant Experience</label>
                <input value={f.yearsExperience} onChange={e => set("yearsExperience", e.target.value)}/>
              </div>
              <div className="field">
                <label>Available From</label>
                <input type="date" value={f.availability} onChange={e => set("availability", e.target.value)}/>
              </div>
            </div>

            <div className="field">
              <label>Notes</label>
              <textarea value={f.notes} onChange={e => set("notes", e.target.value)}
                placeholder="Relevant certifications, past project experience, language skills, etc."/>
            </div>

            <FileUploadField label="CV / Resume & Certificates"
              hint="CV plus any trade certificates or qualifications, PDF or image, max 10MB each"
              files={files} setFiles={setFiles} onError={setError}/>

            <button className="btn-g" style={{ width: "100%", marginTop: ".5rem" }} disabled={submitting}>
              {submitting ? "Submitting…" : "Register Interest →"}
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
